<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jjVGSj/tc-custom/9781800321960.jpg?1708779383099" alt="This image is the cover for the book Long Midnight, The WW2 Commando Missions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Long Midnight, The WW2 Commando Missions
      </h1>
      <p class="bookDescription body article font2">
        <p>  <b>“The action gets hot on the icy fjords” in this gripping novel of two British commandos in World War II Norway (<i>Kirkus Reviews</i>).</b><br/>  <br/> Norway, 1943. A land in the grip of Nazi occupation, where men and women still fight for freedom in constant danger from German murder squads and Norwegian traitors.<br/><br/> It is to find such a traitor that two men are sent from Britain. Their mission is twofold. First, to expose—and kill—the traitor. Second, to carry out a brilliant and daring operation of rescue and sabotage. And you can’t hide when the sun never sets . . .<br/>  <br/><b>Praise for the series</b><br/>  <br/> “Tense and convincing.” —<i>The </i><i>Observer</i><br/><br/> “I think it’s the best thing of its kind I’ve ever read. I literally couldn’t put it down.” —Leslie Charteris, author of The Saint novels<br/><br/> “A gripping read.”—<i>The </i><i>Sunday Times</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan White
      </h2>
      
      <p class="authorDescription body article">Alan White’s brilliant war novels have the authenticity born of personal experience. As leader of a commando unit in World War II, he made more than a dozen operational jumps into Occupied Europe. He also fought in North Africa. After the war he joined the BBC and enjoyed a wide-ranging media career including the role of White House correspondent in the US. He has written over forty novels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b25ff9d0